/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Text_Import_TitleInputs */

const en_plain_text_import_title = /** @type {(inputs: Plain_Text_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plain Text Import`)
};

const fr_plain_text_import_title = /** @type {(inputs: Plain_Text_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importation de texte brut`)
};

const de_plain_text_import_title = /** @type {(inputs: Plain_Text_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import von Klartext`)
};

const it_plain_text_import_title = /** @type {(inputs: Plain_Text_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importazione di testo normale`)
};

const ru_plain_text_import_title = /** @type {(inputs: Plain_Text_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт простого текста`)
};

const es_plain_text_import_title = /** @type {(inputs: Plain_Text_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importación de texto sin formato`)
};

const zh_cn2_plain_text_import_title = /** @type {(inputs: Plain_Text_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`纯文本导入`)
};

const ja_plain_text_import_title = /** @type {(inputs: Plain_Text_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プレーンテキストインポート`)
};

const hi_plain_text_import_title = /** @type {(inputs: Plain_Text_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`साधारण पाठ आयात`)
};

const pt_pt2_plain_text_import_title = /** @type {(inputs: Plain_Text_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importação de texto simples`)
};

/**
* | output |
* | --- |
* | "Plain Text Import" |
*
* @param {Plain_Text_Import_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_title = /** @type {((inputs?: Plain_Text_Import_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_plain_text_import_title(inputs)
	if (locale === "de") return de_plain_text_import_title(inputs)
	if (locale === "it") return it_plain_text_import_title(inputs)
	if (locale === "ru") return ru_plain_text_import_title(inputs)
	if (locale === "es") return es_plain_text_import_title(inputs)
	if (locale === "zh-CN") return zh_cn2_plain_text_import_title(inputs)
	if (locale === "ja") return ja_plain_text_import_title(inputs)
	if (locale === "hi") return hi_plain_text_import_title(inputs)
	if (locale === "pt-PT") return pt_pt2_plain_text_import_title(inputs)
	return en_plain_text_import_title(inputs)
});